import { useLayoutEffect, useRef } from "react";

// Los bloques marcados con la clase `pp-aparece` entran con un fundido corto
// cuando llegan a la pantalla (CSS en index.css, grupo "Presentación
// pública"). Pedido del fundador el 29-sep-2026: "más acción, más
// movimiento".
//
// Se enciende SOLO si hay IntersectionObserver y la persona no pidió menos
// movimiento: recién ahí la raíz queda con data-pp-anim="on", que es lo único
// que esconde algo. Sin eso (tests, navegadores viejos, reduced-motion) la
// página se ve entera y quieta. Va en useLayoutEffect para marcar la raíz
// antes de pintar: si no, lo que ya está a la vista parpadearía.
//
// `data-visto` es un atributo y no una clase: React reescribe className en
// cada cambio de estado y se comería la marca.
export function useAparecerAlBajar() {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const raiz = ref.current;
    if (!raiz || typeof window === "undefined" || !("IntersectionObserver" in window)) return undefined;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    raiz.dataset.ppAnim = "on";
    const obs = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        e.target.dataset.visto = "1";
        obs.unobserve(e.target);
      }
    }, { rootMargin: "0px 0px -8% 0px" });
    const observar = () => raiz.querySelectorAll(".pp-aparece:not([data-visto])").forEach((el) => obs.observe(el));
    observar();
    // Lo que se monta después (la lista plegada al abrirse) también entra.
    const mo = typeof MutationObserver !== "undefined" ? new MutationObserver(observar) : null;
    mo?.observe(raiz, { childList: true, subtree: true });
    return () => {
      obs.disconnect();
      mo?.disconnect();
      delete raiz.dataset.ppAnim;
    };
  }, []);
  return ref;
}

// Retraso escalonado para una lista que entra en cascada.
export const retraso = (ms) => ({ "--pp-retraso": `${ms}ms` });
